import { InformalFeedbackRequestNotification } from '../../types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import { informalFeedbackRequestPath } from '../../utils'
import { iconForNotification } from './utils'

interface Props {
  notification: InformalFeedbackRequestNotification
  onClose: () => void
}

export const ReviewDismissedNotification = (props: Props) => {
  const { notification } = props
  const requestType = notification.subject.request_type
  const isSuggestion = notification.subject.is_suggestion
  const isMention = notification.subject.is_mention
  const path = informalFeedbackRequestPath({ notification })

  const title = () => {
    if (isMention) return `mentioned you in their ${isSuggestion ? 'suggestion' : 'request'} feedback`

    if (isSuggestion) return 'skipped reviewing your suggestions'

    switch (requestType) {
      case 'approval':
        return 'skipped approving your request'
      case 'read_receipt':
        return 'skipped marking as read'
      case 'review':
      default:
        return 'skipped reviewing this file'
    }
  }

  return (
    <BaseNotificationItem
      {...props}
      title={title()}
      icon={iconForNotification(notification)}
      path={path}
      aria-label="Review Dismissed Notification"
    />
  )
}
